<!-- Button -->
<button mat-icon-button [matMenuTriggerFor]="userActions" aria-label="Konto">
    @if (showAvatar && user.avatar) {
        <img class="h-7 w-7 rounded-full" [src]="user.avatar" alt="" />
    } @else {
        <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
    }
</button>

<mat-menu [xPosition]="'before'" #userActions="matMenu">
    <div class="flex flex-col px-4 py-3 leading-none">
        <span>Zalogowano jako</span>
        <span class="mt-1.5 text-md font-medium">{{ user.username }}</span>
    </div>
    <mat-divider class="my-2"></mat-divider>
    <button mat-menu-item (click)="signOut()">
        <mat-icon
            [svgIcon]="'heroicons_outline:arrow-right-on-rectangle'"
        ></mat-icon>
        <span>Wyloguj</span>
    </button>
</mat-menu>
